import React, { useEffect } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { exitTheme } from '../../hookState/ThemeState';
// import { useTranslation } from 'react-i18next';
// import Home from '../../pages/Home/Home';
import Landing from '../../pages/Home/Landing';
const Dashboard = () => {
    // const { t } = useTranslation();
    useEffect(() => {
        exitTheme();
    }, []);
    return (
        <>
            {/* <div>{t('dashboard')}</div> */}
            {/* <Home /> */}
            <Landing />
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.DASHBOARD,
        component: Dashboard,
    },
    name: 'Dashboard',
};
